import scribdAuthorize from "./scribd_oauth.js"

$(function () {
  $(".signup-account-gating").click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    const returnTo = $(this).data("return-to") || location.href
    scribdAuthorize({ from_source: returnTo })
  })
})
